export const availableLangs = [
  'en',
  'hu',
  'el',
  'hr',
  'kk',
  'et',
  'be',
  'lt',
  'lv',
  'pl',
  'ru',
  'sv',
  'de',
  'it',
  'bg',
  'da',
  'pt',
  'fr',
  'fi',
  'ro',
  'sr',
  'uk',
  'es',
  'az',
  'zh',
  'vi',
  'nb',
  'lo'
];
